import { Button, Modal } from "react-bootstrap"
import useAxios from "../hooks/useAxios"
import { useState } from "react";
import { useFeedBack } from "../context/FeedBackContext";

const ImportPayrrolWorkerItemsModal = ({
    show,
    setShowModal,
    onUpdate,
    payrrolId,
}) => {

    const { setCustomAlert } = useFeedBack();

    const [file, setFile] = useState(null);

    const [errors, setErrors] = useState([]);

    const [{ loading: loadingImport }, importFile] = useAxios({ url: `/payrrol-worker-items/import`, method: 'POST' }, { manual: true, useCache: false });

    const [{ loading: loadingDownload }, donwLoadTemplate] = useAxios({ responseType: 'blob', url: `/payrrols/${payrrolId}/download-template` }, { manual: true, useCache: false });

    const handleDonwLoad = () => {
        donwLoadTemplate().then((response) => {
            const excelBlobUrl = URL.createObjectURL(response?.data);
            const aToDownload = document.getElementById('downloadLink');
            aToDownload.href = excelBlobUrl;
            aToDownload?.click();
            window.URL.revokeObjectURL(excelBlobUrl);
        })
    }

    const handleSubmit = (e) => {

        const data = new FormData();

        data?.append('file', file, file?.name);
        data?.append('payrrol_id', payrrolId);

        importFile({ data }).then((response) => {
            if (response?.data?.errors?.length > 0) {
                setErrors(response?.data?.errors);
            } else {
                setShowModal(false);
                onUpdate?.();
                setCustomAlert({ show: true, message: "Los cambios se han agregado de forma exitosa.", severity: "success", title: 'Operación exitosa' });
            }
        })
    }


    return (
        <Modal show={show} onHide={() => setShowModal(false)} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    Importar haberes
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-end mb-3">
                    <button disabled={loadingDownload} onClick={handleDonwLoad} className="btn btn-primary btn-xs">
                        {loadingDownload ? 'Cargando...' : 'Descargar plantilla'}
                    </button>
                </div>
                <input type="file" className="form-control" onChange={(e) => setFile(e.target.files[0])} />
                <br />
                {
                    errors?.map((errorFile, i) => {
                        return (
                            <div key={i + 1} className="mb-3">
                                Error en la fila: <b>{errorFile?.row}</b> el valor del haber: <b>{errorFile?.column}</b> no puede ser mayor a: <b>{errorFile?.max}</b>.
                            </div>
                        )
                    })
                }

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Cerrar
                </Button>
                <Button disabled={loadingImport || !file} variant="primary" onClick={handleSubmit}>
                    {
                        loadingImport ?
                            <div className="spinner" style={{ width: 25, height: 25 }}>
                                <div className="double-bounce1 bg-light"></div>
                                <div className="double-bounce2 bg-light"></div>
                            </div>
                            :
                            'Enviar'
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ImportPayrrolWorkerItemsModal;